import { useSelector } from 'react-redux';
import { useState } from 'react';
import FetchHelper from '../../helpers/fetch_helper';
import { Button } from '@mui/material';
import JsonViewer from '../shared/jsonviewer';
import Actions from '../../actions/actions';
import ShowMoreText from '../forms/show_more_text';

const Ensemble_page = () => {
  const customerId = useSelector((redux) => redux.view?.id);
  const sponsorApiEventHistory = useSelector((redux) => redux.sponsorApiEventHistory);
  const [project, setProject] = useState(null);

  const VALID_ACTIONS = [
    { id: 'CUSTOMER_HOLD_PLACE', label: 'Place Hold' },
    { id: 'CUSTOMER_HOLD_REMOVE', label: 'Remove Hold' },
    { id: 'CUSTOMER_CHANGEORDER_HOLD_PLACE', label: 'Add ChangeOrder Hold' },
    { id: 'ACTIVATE_CS', label: 'Create/Activate Project' },
    { id: 'CANCEL_CS', label: 'Cancel Project' },
    { id: 'ACTIVATE_PER', label: 'Milestone PER' },
    { id: 'ACTIVATE_SC', label: 'Milestone SC' },
    { id: 'ACTIVATE_PTO', label: 'Milestone PTO' },
  ];

  const runAction = (action, note) => {
    FetchHelper.fetchJson(
      `customers/${customerId}/ensemble-project/${action}/force${note?.length > 1 ? `?notes=${note}` : ''}`,
      { version: '/qa', method: 'POST' }
    );
  };

  const getProject = async () => {
    let proj = await FetchHelper.fetchJson(`customers/${customerId}/ensemble-project`, {
      version: '/qa',
      method: 'GET',
    });
    setProject(proj);
    await Actions.fetchSponsorApiEvents(customerId);
  };

  const safetyParse = (json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      return json;
    }
  };

  return (
    <div>
      <div className={'ensemble-header'}>
        <h3 style={{ display: 'inline-block' }}>Ensemble View TroubleShooting</h3>
        &nbsp;&nbsp;<h4 style={{ display: 'inline-block' }}>customerId[{customerId}]</h4>
      </div>
      <table style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
        <tr>
          <td className={'ensemble-left'} style={{ border: '1px solid black' }}>
            <h3>Project</h3>
            <Button onClick={() => getProject()}>Fetch</Button>
            <JsonViewer json={project} />
          </td>
          <td className={'ensemble-body'}>
            <h3>Ensemble Logs</h3>
            <div>
              <table style={{ border: '1px solid black' }} border={'1'} cellPadding="1" cellSpacing="1" width={'100%'}>
                <tr>
                  <th>ID</th>
                  <th>Action</th>
                  <th>State</th>
                  <th>Request</th>
                  <th>Response</th>
                </tr>
                {sponsorApiEventHistory?.map((event, i) => (
                  <tr key={i} style={{ backgroundColor: i % 2 === 1 ? '#fff' : '#eee' }}>
                    <td style={{ padding: '5px' }}>{event.id}</td>
                    <td style={{ padding: '5px' }}>{event.action}</td>
                    <td style={{ padding: '5px' }}>{event.failed ? '🛑' : '✅'}</td>
                    <td style={{ padding: '5px' }}>
                      <ShowMoreText summary={''} text={<JsonViewer data={safetyParse(event.rawRequest)} />} />{' '}
                    </td>
                    <td style={{ padding: '5px' }}>
                      <ShowMoreText summary={''} text={<JsonViewer data={safetyParse(event.rawResponse)} />} />{' '}
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </td>
          <td className={'ensemble-right'}>
            <h3>Actions</h3>
            <div>
              {VALID_ACTIONS.map((action, i) => (
                <div key={i} style={{ paddingBottom: '20px' }}>
                  <Button variant={'contained'} color={'success'} onClick={() => runAction(action.id)}>
                    {action.label}
                  </Button>
                </div>
              ))}
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default Ensemble_page;
